export function nameRule(rule, value, callback) {
  // let reg = /@thingsboard\.org$/
  let reg = /.*@.*/;
  if (value === "") {
    callback(new Error("请输入用户名"));
  } else if (!reg.test(value)) {
    callback(new Error("请输入正确的用户名"));
  } else {
    callback();
  }
}

export function passRule(rule, value, callback) {
  // let reg = /(^[a-zA-Z][a-zA-Z\s]{0,20}[a-zA-Z]$)/
  let reg = /^.{6,}$/;
  if (value === "") {
    callback(new Error("请输入密码"));
  } else if (!reg.test(value)) {
    callback(new Error("请输入正确的密码"));
  } else {
    callback();
  }
}
let identifyCode = "";
export function setIdentifyCode(code) {
  identifyCode = code;
}
export function verifyCodeRule(rule, value, callback) {
  if (value === "") {
    callback(new Error("请输入验证码"));
  } else if (value !== identifyCode) {
    callback(new Error("验证码不正确!"));
  } else {
    callback();
  }
}
